import React from 'react';
import Modal from './Modal';
import { Button } from 'react-bootstrap';
import LoadingButton from './LoadingButton';
import '../../../css/modal.less';

const actionCaption = (caption) => {
    switch (caption) {
    case 'Delete':
        return 'Deleting...';
    case 'Remove':
        return 'Removing...';
    default:
        return 'Working...';
    }
};

const Confirm = ({
    show,
    onCancel,
    onConfirm,
    title,
    messages,
    container,
    buttonStyle = 'primary',
    buttonCaption = 'Confirm',
    isInProgress = null, // use the LoadingButton with the spinner if progress is given
}) => show ? (
    <Modal
        className="confirm-modal"
        title={title}
        container={container}
        onHide={onCancel}
        renderBody={() => (
            <div className="container-fluid">
                {
                    messages.map(message => <div className="message-line" key={message}>{message}</div>)
                }
            </div>
        )}
        renderFooter={() => (
            <>
                {isInProgress === null ? (
                    <>
                        <Button onClick={onCancel} className="btn-outline">Cancel</Button>
                        <Button onClick={onConfirm} bsStyle={buttonStyle}>{buttonCaption}</Button>
                    </>
                ) : (
                    <>
                        <Button
                            onClick={onCancel}
                            className="btn-outline"
                            disabled={isInProgress}
                        >
                            {'Cancel'}
                        </Button>
                        <LoadingButton
                            className="btn btn-danger"
                            onClick={onConfirm}
                            isLoading={isInProgress}
                        >
                            { isInProgress ? actionCaption(buttonCaption) : buttonCaption }
                        </LoadingButton>
                    </>
                )}
            </>
        )}
    />
) : null;

export default Confirm;
